import { render, staticRenderFns } from "./editAdminSubmit.vue?vue&type=template&id=50be9134&scoped=true&"
import script from "./editAdminSubmit.vue?vue&type=script&lang=js&"
export * from "./editAdminSubmit.vue?vue&type=script&lang=js&"
import style0 from "./editAdminSubmit.vue?vue&type=style&index=0&id=50be9134&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50be9134",
  null
  
)

export default component.exports